import styles from './homeTaskCard.module.scss';
import Avatar from '@/components/UI/Avatar/Avatar';
import Icon from '@/assets/icons/Icons';
import { ITask } from '@/api/tasks/types';

interface Tag {
  id: string;
  name: string;
  color: string;
}

interface Assignee {
  id: string;
  fullName: string;
  avatar: string;
}

// The ITask type from the API doesn't contain all the necessary fields.
// We extend it here for use in the home page.
interface HomePageTask extends ITask {
  tags?: Tag[];
  assignees?: Assignee[];
  totalComments?: number;
  estimatedTime?: number;
  realTime?: number;
}

const tagColorMap: Record<string, string> = {
  yellow: styles['tag--yellow'],
  gray: styles['tag--gray'],
  blue: styles['tag--blue'],
  green: styles['tag--green'],
  red: styles['tag--red'],
};

interface HomeTaskCardProps {
  task: HomePageTask;
  onClick: () => void;
}

const HomeTaskCard: React.FC<HomeTaskCardProps> = ({ task, onClick }) => {
  return (
    <div className={styles['task-board-card']} onClick={onClick}>
      <div className={styles['task-board-card__header']}>
        <span className={styles['task-board-card__title']}>{task.title}</span>
      </div>
      <div className={styles['task-board-card__tags']}>
        {task.tags?.map((tag: Tag) => (
          <span key={tag.id} className={`${styles.tag} ${tagColorMap[tag.color] || styles['tag--gray']}`}>
            {tag.name}
          </span>
        ))}
      </div>
      <div className={styles['task-board-card__footer']}>
        <div className={styles['task-board-card__assignee']}>
          {task.assignees?.map((assignee: Assignee) => (
            <Avatar key={assignee.id} name={assignee.fullName} src={assignee.avatar} size="sm" />
          ))}
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            <Icon name="tracker" width={14} height={14} color="var(--color-text-secondary)" />
            <span className={styles['task-board-card__date']}>
              {task.estimatedTime || 0}h / {task.realTime || 0}h
            </span>
          </div>
          {task.endDate && (
            <div className="flex items-center gap-1">
              <Icon name="reindex" width={14} height={14} color="var(--color-text-secondary)" />
              <span className={styles['task-board-card__date']}>
                {new Date(task.endDate).toLocaleDateString()}
              </span>
            </div>
          )}
          {task.totalComments && task.totalComments > 0 && (
            <div className={styles['task-board-card__comments']}>
              <span>{task.totalComments}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeTaskCard; 